import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import maximaZ from "../../images/Maxima-Z.png";
import "../../../src/product.css";

const MaximaZ = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">MAXIMA-Z</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={maximaZ}
              alt="Bajaj Maxima Z"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              The Maxima Z is the Bajaj’s ultimate last-mile affordable people
              carrier three-wheeler. The Maxima Z passenger carriers take
              forward the reliability, trust and quite lower cost to operate
              for the entrepreneurs who use this vehicle for their business.
              Maxima Z has all the key performance characteristics such as
              power, pickup, higher fuel-mileage, modern stylish design and an
              overall promising 3-wheeler to enhance your business.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>470.5 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>5 Forward + 1 Reverse Gear</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Diesel</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>790 kg</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Tank Capacity</span>
              <strong>8 L</strong>
            </div>

            <div className="spec-card">
              <span>Passenger Capacity</span>
              <strong>1D + 3</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default MaximaZ;
